export default __webpack_public_path__ + "static/media/Adverse-Event.173d3886.svg";